<!-- <div class="mobBodyPanel">
<div class="mainPanel reportMainPanel clientMainPanel"> -->
    <!-- <div class="midPanel mobMidPanel"> -->
        <div class="mobBackSec">
            <a (click)="navigateToAttendance()" href="#" class="bckArrow"><i class="material-icons">arrow_back</i>Apply for leave</a>                  
         </div>
        <!-- <div class="fullPanel">
            <div class="breadcrumbSec">
               
                <div class="breadcrumbText">
                    <p><a href="#">Home</a> / <a href="#">Attendance</a> / Leave Application </p>
                </div>
            </div>
        </div> -->
            <!-- <div class="topRightSec">
                <div class="confiFieldSec">
                    <a href="#" class="confiLink" id="confiLink">Configure fields</a>
                    <div class="filterBox" id="filterList">
                        <ul class="filterList">
                            <li><label>Select All <input type="checkbox" name=""></label></li>
                            <li><label>Client Name <input type="checkbox" name=""></label></li>
                            <li><label>Client Mobile <input type="checkbox" name=""></label></li>
                            <li><label>Client Email ID<input type="checkbox" name=""></label></li>
                            <li><label>Client Type<input type="checkbox" name=""></label></li>
                            <li><label>Contact Person<input type="checkbox" name=""></label></li>
                            <li><label>Client City<input type="checkbox" name=""></label></li>
                            <li><label>Address<input type="checkbox" name=""></label></li>
                            <li><label>Departments<input type="checkbox" name=""></label></li>
                        </ul>
                    </div>
                </div>
            </div> -->
       
        <div class="fullContainer">
            <div class="formContainer">
                <h3>Apply for leave</h3>
                <!-- <div class="tCountLeaveDiv">
                    <p>You Have 7.5 casual leave and 1 flexi leave in your account</p>
                </div> -->
                <form action="#">
                    <div class="formScroll  mCustomScrollbar" data-mcs-theme="minimal-dark">
                        <div class="formSec">
                            <div class="leftForm">
                                <div class="form-group">
                                    <div class="selectboxSec ">
                                        <ng-select 
                                            class="select form-control e1" 
                                            [items]="leaveTypeListWithFlag" 
                                            bindLabel="name"
                                            [virtualScroll]="true" 
                                            [closeOnSelect]="true" 
                                            [(ngModel)]="selectedLeaveType"
                                            (change)="changeLeaveType(selectedLeaveType);"
                                            name="selectedLeaveType" 
                                            [ngClass]="selectedLeaveType ? 'selectfocus' : ''"
                                            placeholder="Leave Type">
                                        </ng-select>
                                        <div class="floating-label">Leave Type</div>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="selectedLeaveType && (selectedLeaveType.isFullDay || selectedLeaveType.isHalfDay)">
                                    <div class="selectboxSec ">
                                        <ng-select 
                                            class="select form-control e1" 
                                            [items]="dayList" 
                                            bindLabel="text"
                                            [virtualScroll]="true" 
                                            [closeOnSelect]="true" 
                                            [(ngModel)]="selectedDayType"
                                            name="selectedDayType" 
                                            [ngClass]="selectedDayType ? 'selectfocus' : ''"
                                            placeholder="Select Day" 
                                            [disabled]="isdisabled" (change)="changeDay(selectedDayType);">
                                        </ng-select>
                                        <div class="floating-label">Select Day</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="datePicker" id="reportrange">
                                        <input type="text" value="" class="form-control"  (keydown)="keydown($event)" required>
                                        <!-- <span></span> --><i class="material-icons">event</i>
                                        <div class="floating-label">From</div>
                                    </div>
                                </div>
                                <!-- <div class="form-group">
                                    <div class="datePicker" id="reportrange">
                                        <input type="text" value="" class="form-control" required>
                                       <i class="material-icons">event</i>
                                        <div class="floating-label">To</div>
                                    </div>
                                </div> -->
                                <div class="form-group disabledDiv">
                                    <div class="inputSec">
                                        <input type="text" value="" name="totalLeaves" class="form-control disabled" [(ngModel)]="totalLeaves" required />
                                        <div class="floating-label">Total Leave <span class="aster">*</span></div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="inputSec">
                                        <input type="text" name="reasonForLeave" value="" class="form-control" [(ngModel)]="reasonForLeave" required />
                                        <div class="floating-label">Reason for taking leave <span class="aster">*</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="informSec">
                            <h4>I Want to inform</h4>
                            <div class="informBox">

                                <div class="informBoxDiv">
                                    <div class="informInnerDiv">
                                        <div class="informHead">
                                            <h5>Product Team</h5>
                                        </div>
                                        <div class="informBody">
                                            <input class="tagsinputdiv" type="text" value=""
                                                placeholder="Start typing product team name" data-role="tagsinput" />
                                        </div>
                                    </div>
                                    <div class="informInnerDiv">
                                        <div class="informHead">
                                            <h5>Peer</h5>
                                        </div>
                                        <div class="informBody">
                                            <input class="tagsinputdiv" type="text" value=""
                                                placeholder="Start typing the peer's name" data-role="tagsinput" />
                                        </div>
                                    </div>
                                    <div class="informInnerDiv">
                                        <div class="informHead">
                                            <h5>Message</h5>
                                        </div>
                                        <div class="informBody">
                                            <textarea class="tagstextArea" cols="2" rows="2"
                                                placeholder="Start typing the message"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="informCheckDiv">
                                    <p><label><input type="checkbox" name=""></label>After approval of my leave
                                        application, send my leave information and message to product team or peers</p>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </form>
                <div class="filter-sec-foot clearfix">
                    <button type="button" class="btn btn-default ripple blueBtn" (click)="onLeaveApply()">Apply</button>
                    <button type="button" class="btn btn-default ripple lineBlueBtn" (click)="navigateToAttendance()">Cancel</button>
                </div>
            </div>
        </div>
    <!-- </div> -->
<!-- </div>
</div> -->